const encode = encodeURIComponent;

export default (requests, axios) => {
    return {
      reportError: (data) => {
        return requests.post('/error/report', data);
      }
    }
};